import { produce } from "immer";

const initialState = { userGroup: [], total: 0, loading: false };

const UserGroupReducer = produce((draft = initialState, action = {}) => {
  switch (action.type) {
    case "FETCH_USER_GROUP":
      draft.loading = true;
      return draft;
    case "FETCH_USER_GROUP_SUCCESS":
      draft.userGroup = action.payload.data;
      draft.total = action.payload.total;
      draft.loading = false;
      return draft;
    case "FETCH_USER_GROUP_FAIL":
      draft.loading = false;
      return draft;
    default:
      return draft;
  }
});

export default UserGroupReducer;
